import styled from 'styled-components';

interface ContentProps {
  justifyBadge?: string;
}
interface BadgeProps {
  backgroundColor?: string | number;
}

export const Content = styled.div<ContentProps>`
  display: flex;
  align-items: center;
  justify-content: ${({ justifyBadge }) => justifyBadge ?? 'normal'};
  width: 100%;
`;

export const BadgeIcon = styled.div<BadgeProps>`
  min-height: 12px;
  height: 12px;
  min-width: 12px;
  width: 12px;
  border-radius: 50%;
  background-color: ${({ backgroundColor }) =>
    (backgroundColor &&
      (typeof backgroundColor === 'number'
        ? `#${backgroundColor}`
        : backgroundColor)) ||
    'transparent'};
`;
